<div class="sheet">
    <div class="sheet-head">
        <h2>{{ isNew ? 'Modul hinzufügen' : 'Modul bearbeiten' }}</h2>
        <button class="x" (click)="close()" aria-label="Schließen">×</button>
    </div>

    <div class="grid2">
        <label class="field" [class.changed]="addressChanged">
            Adresse *
            <select *ngIf="isOtmType" name="moduleAddressOtm" [(ngModel)]="address" [class.bad]="addressError">
                <option *ngFor="let a of otmAddressOptions" [ngValue]="a">{{ a }}</option>
            </select>
            <input *ngIf="!isOtmType" name="moduleAddress" type="number" inputmode="numeric" min="1" max="99"
                   [class.bad]="addressError"
                   [(ngModel)]="address">
            <span class="msg" *ngIf="addressError">{{ addressError }}</span>
            <span class="was" *ngIf="addressChanged">vorher {{ originalAddress }}</span>
            <span *ngIf="!addressError && !addressChanged">frei wählbar, wie am Modul eingestellt</span>
        </label>
        <label class="field" [class.changed]="typeChanged">
            Modultyp *
            <select name="moduleType" [(ngModel)]="uvsType">
                <option *ngFor="let option of typeOptions" [ngValue]="option.value">{{ option.label }}</option>
            </select>
            <span class="was" *ngIf="typeChanged">vorher {{ getTypeLabel(originalType) }}</span>
        </label>
    </div>

    <div class="note info" *ngIf="isNew">
        Neues Modul mit Standardwerten. Ob das Gateway es findet, zeigt sich nach dem Senden und Neuladen der Daten.
    </div>

    <fieldset *ngIf="isSm03">
        <legend>IR-Zähler</legend>
        <div class="ir-row">
            <label class="field">Eingang
                <input type="text" disabled value="254">
            </label>
            <label class="field">IR-Zähler Typ
                <input type="text" disabled value="M-Bus / wired">
            </label>
        </div>
    </fieldset>

    <fieldset *ngIf="hasIr && !isSm03">
        <legend>IR-Zähler</legend>
        <div class="ir-row" *ngFor="let ir of irUartCfg; index as i; trackBy: trackByIndex">
            <label class="field">Eingang
                <select [name]="'irInput' + i" [(ngModel)]="ir.input">
                    <option *ngFor="let n of irInputOptions" [ngValue]="n"
                            [disabled]="isIrInputUsed(n, i)">{{ n }}
                    </option>
                </select>
            </label>
            <label class="field">IR-Zähler Typ
                <select [name]="'irDevice' + i" [(ngModel)]="ir.device">
                    <option *ngFor="let t of irTypeOptions" [value]="t">{{ t }}</option>
                </select>
            </label>
            <button type="button" class="icon-btn" *ngIf="irUartCfg.length > 1"
                    (click)="removeIr(i)" aria-label="Eingang entfernen">×
            </button>
        </div>
        <button type="button" class="add-ir" [disabled]="!canAddIr" (click)="addIr()">
            + IR-Eingang hinzufügen
        </button>
    </fieldset>

    <fieldset *ngIf="isOtmType">
        <legend>Außentemperaturfühler</legend>
        <label class="field">Fühlertyp
            <input type="text" disabled [value]="value(sensorTypeName)" placeholder="–">
        </label>
        <div class="grid2">
            <label class="field">B-Wert
                <input type="text" disabled [value]="value(sensorB)" placeholder="–">
            </label>
            <label class="field">Referenzwiderstand
                <span class="suffix"><input type="text" disabled [value]="value(sensorReferenceResistance)"
                                            placeholder="–"><span>Ω</span></span>
            </label>
        </div>
    </fieldset>

    <div class="actions">
        <button class="btn" (click)="close()">Abbrechen</button>
        <button class="btn primary" [disabled]="!isValid" (click)="save()">Übernehmen</button>
    </div>
    <p class="footnote">„Übernehmen“ ändert nur die Auswahl. Ans Gateway geht erst „Modulkonfiguration senden“.</p>
</div>
